import MapPage from "../components/Localização";
import Contact from "../components/contact";

function Contato(){
    return(
        <div>
            <Contact/>
            <MapPage/> 
         </div>
    )

    
}
export default Contato;